import { AppButton } from "@/components/teacher/AppButton";
import { TeacherPage } from "@/components/teacher/TeacherPage";
import { ClassroomGrid } from "@/components/teacher/classroom/ClassroomGrid";
import { useT } from "@/i18n";
import { useNavigate } from "@tanstack/react-router";

export function ClassroomsPage() {
  const navigate = useNavigate();
  const t = useT();

  return (
    <TeacherPage
      title={t["classrooms.title"]}
      actions={
        <AppButton tone="glass" onClick={() => navigate({ to: "/teacher" })}>
          {t["common.back"]}
        </AppButton>
      }
    >
      <ClassroomGrid />
    </TeacherPage>
  );
}
